import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../config/date_format';
import {FuseConfig} from '../../@fuse/types';
import {fuseConfig} from '../fuse-config';
import {fuseConfig_qalqul_theme} from '../fuse-config/qalqul-theme';
import {fuseConfig_robimotion_theme} from '../fuse-config/robimotion-theme';
import {User} from '../dto/user';
import {UserRef} from '../dto/user-ref';
import {NUMBER_WORDS} from '../config/config';
import {MappedMarket} from '../dto/mapped-market';
import {Market} from '../dto/market';
import {MiniMarket} from '../dto/mini-market/mini-market';
import swal from 'sweetalert2';

export function getEnumSelector(pTargetEnum: any): { title: string; value: any, selected: boolean }[] {
    return Object.keys(pTargetEnum).map(pKey => ({value: pKey, title: pTargetEnum[pKey], selected: false}));
}

export function findEnum(pTargetEnum: any, pTargetKey: string): string {
    return Object.keys(pTargetEnum).filter(pKey => pTargetEnum[pKey] === pTargetKey)[0];
}

export function padString(pInputString: string, pPadString: string, pLength: number, pLeft = true): string {
    return pLeft ? pInputString.padStart(pLength, pPadString) : pInputString.padEnd(pLength, pPadString);
}

export function arrayRemove(pArray: any[], pItem: any): any[] {
    const index = pArray.indexOf(pItem);
    if (index > -1) {
        pArray.splice(index, 1);
    }
    return pArray;
}

export function getDaysInMonth(month, year): number {
    return new Date(year, month, 0).getDate();
}

export function getOrganizationLogoName(pOrgCode: string): string {
    let imagePath = 'biz_motion.png';

    const siteLink = window.location.href;
    if (siteLink.includes('robisfaplusg2.robimotion.com') || siteLink.includes('sfaplus.robisfa.com') ) {
        return 'assets/images/logos/robi.png';
    }

    if (pOrgCode != null) {
        if (pOrgCode.toUpperCase() === 'MUNDI') {
            imagePath = 'mundi.png';
        } else if (pOrgCode.toUpperCase() === 'RNG') {
            imagePath = 'rangs.png';
        } else if (pOrgCode.toUpperCase() === 'BIO') {
            imagePath = 'biopharma.png';
        } else if (pOrgCode.toUpperCase() === 'SMC') {
            imagePath = 'smcpharma.png';
        } else if (pOrgCode.toUpperCase() === 'ALBN') {
            imagePath = 'albion-org-432.png';
        } else if (pOrgCode.toUpperCase() === 'STEC') {
            imagePath = 'somatec.png';
        } else if (pOrgCode.toUpperCase() === 'AUS') {
            imagePath = 'auspicious.png';
        } else if (pOrgCode.toUpperCase() === 'EVST') {
            imagePath = 'everest.png';
        } else if (pOrgCode.toUpperCase() === 'SEL') {
            imagePath = 'sel.png';
        } else if (pOrgCode.toUpperCase() === 'SHARIF') {
            imagePath = 'sharif.png';
        } else if (pOrgCode.toUpperCase() === 'LABAID') {
            imagePath = 'labaid.png';
        } else if (pOrgCode.toUpperCase() === 'DBLP') {
            imagePath = 'dblpharma.png';
        } else if (pOrgCode.toUpperCase() === 'MSHISHU') {
            imagePath = 'mshishu.png';
        } else if (pOrgCode.toUpperCase() === 'GOODMAN') {
            imagePath = 'goodman.png';
        } else if (pOrgCode.toUpperCase() === 'JIBON') {
            imagePath = 'jibonalo.png';
        }
    }
    return imagePath;
}

export function getOrganizationTheme(pOrgCode: string): FuseConfig {
    let fuseConf = fuseConfig;
    if (pOrgCode == null) {
        return fuseConf;
    } else if (pOrgCode === 'qalqul') {
        fuseConf = fuseConfig_qalqul_theme;
    }
    else if (window.location.href.includes('robimotion') || window.location.href.includes('robisfa')){
        fuseConf = fuseConfig_robimotion_theme;
    }
    return fuseConf;
}

export function getDatesInBetween(pStartDate: string, pEndDate: string): string[] {
    const dates: string[] = [];
    const currentDate = moment(pStartDate).startOf('day');
    const endDate = moment(pEndDate).startOf('day');

    while (currentDate.diff(endDate) <= 0) {
        dates.push(currentDate.clone().format(SERVER_DATE_FORMAT_WITHOUT_TIME));
        currentDate.add(1, 'days');
    }

    return dates;
}

export function getId(pObj: any): number {
    if (pObj) {
        return pObj.Id || pObj.id;
    } else {
        return null;
    }
}

export function convertToUserRef(pUser: User): UserRef {
    const userRef = new UserRef();
    userRef.id = pUser.Id;
    userRef.name = pUser.Name || pUser.UserName;
    userRef.code = pUser.Code;
    userRef.mobile = pUser.Mobile;
    userRef.designation = pUser.Designation;

    return userRef;
}


export function convertNumberToText(pValue: number, ext?: string): string {
    const paisaSection = pValue.toString().split('.')[1];
    const convertedToString = pValue.toString().split('.')[0].split('');
    const tenthSection = convertedToString.splice(convertedToString.length - 2, 2).join('');
    const hundredSection = convertedToString.splice(convertedToString.length - 1, 1).join('');
    const thousandSection = convertedToString.splice(convertedToString.length - 2, 2).join('');
    const lacSection = convertedToString.splice(convertedToString.length - 2, 2).join('');

    const getPaisaSectionText = (pValue: string) => {

        if (NUMBER_WORDS[parseInt(pValue, 10)]) {
            return NUMBER_WORDS[parseInt(pValue, 10)];
        } else {
            return ``;
        }
    };

    const getTenthSectionText = (pValue: string) => {
        if (NUMBER_WORDS[parseInt(pValue, 10)]) {
            return NUMBER_WORDS[parseInt(pValue, 10)];
        } else {
            return ``;
        }
    };

    const getHundredSectionText = (pValue: string) => {
        if (NUMBER_WORDS[parseInt(pValue, 10)]) {
            return `${NUMBER_WORDS[parseInt(pValue, 10)]} Hundred `;
        } else {
            return ``;
        }
    };

    const getThousandSectionText = (pValue: string) => {
        if (NUMBER_WORDS[parseInt(pValue, 10)]) {
            return `${NUMBER_WORDS[parseInt(pValue, 10)]} Thousand `;
        } else {
            return ``;
        }
    };

    const getLacSectionText = (pValue: string) => {
        if (NUMBER_WORDS[parseInt(pValue, 10)]) {
            return `${NUMBER_WORDS[parseInt(pValue, 10)]} Lac `;
        } else {
            return ``;
        }
    };

    return `${ext ? ext : 'In Words:'} ${getLacSectionText(lacSection)}${getThousandSectionText(thousandSection)}${getHundredSectionText(hundredSection)}${getTenthSectionText(tenthSection)} ${getPaisaSectionText(paisaSection) == '' ? 'Taka' : ` Taka and ${getPaisaSectionText(paisaSection)} paisa`} Only`;
}

export function getEnumTitle(pEnum, pValue) {
    if (pValue) {
        return pEnum[pValue];
    } else {
        return `N/A`
    }
}

export function setText(property) {
    if (property) {
        return property;
    } else {
        return `N/A`;
    }
}

export function checkValidArray(property): boolean {
    return property && property.length > 0;
}

export function prepareMarketForList(market: MappedMarket): any {
    return {
        id: market.Id,
        name: market.Name,
        code: market.Code,
        marketLevel: market.MarketLevel
    }
}

export function prepareSalesCenter(market: MappedMarket): any {
    return {
        id: market.SalesCenter.Id,
        name: market.SalesCenter.Name,
        code: market.SalesCenter.Code
    };
}

export function prepareMiniMarket(market: Market): MiniMarket {
    const miniMarket = new MiniMarket();
    miniMarket.id = market.Id;
    miniMarket.name = market.Name;
    miniMarket.code = market.Code;
    miniMarket.marketLevel = {
        id: market.Id,
        name: market.MarketLevel.Name,
        levelRank: market.MarketLevel.Rank,
    };
    if (market.ParentList) {
        miniMarket.parents = market.ParentList.map(item => ({
            id: item.Id,
            name: item.Name,
            code: item.Code,
            isActive: item.Active,
            marketLevel: {
                id: item.MarketLevel.Id,
                name: item.MarketLevel.Name,
                levelRank: item.MarketLevel.Rank
            },
            parents: []
        }));
    }
    return miniMarket;

}

export function prepareObject(pObject: Object): Object {
    const newObject = {...pObject};
    Object.keys(newObject).forEach(pKey => {
        if (newObject[pKey] == null || newObject[pKey] == 'null' || newObject[pKey] == undefined) {
            delete newObject[pKey];
        }
    });
    return newObject;
}

export function buildQueryParamString(pQueryParams: any): string {
    let convertedQueryParams = '?';
    const validKeys = Object.keys(pQueryParams).filter(key => 
        pQueryParams[key] !== null && 
        pQueryParams[key] !== undefined && 
        pQueryParams[key] !== '' && 
        pQueryParams[key] !== 'null'
    );

    validKeys.forEach((key, index) => {
        convertedQueryParams += `${key}=${pQueryParams[key]}${index === validKeys.length - 1 ? '' : '&'}`;
    });

    return convertedQueryParams === '?' ? '' : convertedQueryParams;
}

export async function openDownloadReportDialog(defaultFilename: string): Promise<{ filename: string, filetype: string } | undefined> {
    const result = await swal({
        title: 'Download Report',
        html:
            '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
            (defaultFilename ? ` value="${defaultFilename}"` : '') +
            '></mat-form-field><br><br>' +
            '<div class="container">\n' +
            '<div class="col-md-12">' +
            '<input class="col-xs-3" type="radio" value="XLSX" id="input1" name="filetype" checked> XLSX' +
            '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="CSV" id="input2" style="margin-left: 20px;"> CSV ' +
            '</div>\n' +
            '</div><div>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Download',
        showLoaderOnConfirm: true,
        preConfirm: () => {
            const isXLSX = (<HTMLInputElement>document.getElementById('input1')).checked;
            const isCSV = (<HTMLInputElement>document.getElementById('input2')).checked;
            const filename = (<HTMLInputElement>document.getElementById('report')).value;
            let filetype = 'XLSX';

            if (isCSV) {
                filetype = (<HTMLInputElement>document.getElementById('input2')).value;
            } else if (isXLSX) {
                filetype = (<HTMLInputElement>document.getElementById('input1')).value;
            }

            return {
                filename: filename ? filename : defaultFilename,
                filetype: filetype
            };
        },
        allowOutsideClick: () => !swal.isLoading()
    });
    if (result && result.value) {
        return result.value;
    }
    return undefined;
}

